// Put Social Security Number into the appropriate format XXX-XX-XXXX
// First replace inserts the first SSN hyphen if there are at least four digits entered
// Second replace inserts the second SSN hyphen if there are at least six digits entered
const formatSsn = value =>
	value ? value.replace(/(...)(.)/, '$1-$2').replace(/(...-..)(.)/, '$1-$2') : '';

export default formatSsn;
